import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserList } from '@authifi/clique-react-ui';
import type { User } from '@authifi/clique-react-ui';

export function UsersPage() {
  const navigate = useNavigate();

  const handleUserSelect = useCallback(
    (user: User) => {
      navigate(`/users/${user.id}`);
    },
    [navigate],
  );

  return (
    <div>
      <h2 className="text-2xl font-semibold text-[var(--clique-fg)] mb-2">Users</h2>
      <p className="text-[var(--clique-fg-muted)] mb-6">Manage tenant users.</p>
      <UserList onUserSelect={handleUserSelect} />
    </div>
  );
}
